module.exports = __webpack_public_path__ + "img/ep1-3.3c2df3ab.png";